import { GeoJsonProperties, RenderContentComponent, RenderContentComponentProps } from '@msaf/maps-common'
import React from 'react'

export interface FeatureFormWrapperProps<TProperties extends GeoJsonProperties = GeoJsonProperties, TContext = unknown>
  extends RenderContentComponentProps<TProperties, TContext> {
  renderContent: RenderContentComponent<TProperties, TContext>
}

export function FeatureFormWrapper<TProperties extends GeoJsonProperties = GeoJsonProperties, TContext = unknown>({
  renderContent: RenderContent,
  ...props
}: FeatureFormWrapperProps<TProperties, TContext>) {
  return (
    <div className='c-context-panel-form'>
      <RenderContent {...props} />
    </div>
  )
}
